exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".challenge-preview{cursor:pointer;padding-top:32px;border-bottom:1px solid #ddd}.challenge-preview h1,.challenge-preview h2{margin:0;font-size:18px}.challenge-preview h2{font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/containers/drawer-toggle/style.scss
// module id = 276
// module chunks = 0